export const colors = {
   primary1: "#14213D",
   primary2: "#2C3750",
   primary3: "#434D64",
   primary4: "#5B6477",
   primary5: "#727A8B",
   secondary1: "#E5E5E5",
   secondary2: "#EAEAEA",
   secondary3: "#EFEFEF",
   accent: "#FCA311",
   accent2: "#514072",
   link: "#0051FF",
   bg: "#FFF",
   fg: "#14213D",
   javascript: "#ccc",
   javascriptDark: "#ccc",
   node: "#ccc",
   mongodb: "#ccc",
   mongodbDark: "#ccc",
   react: "#ccc",
   reactDark: "#ccc",
   redux: "#ccc",
   reduxDark: "#ccc",
   gatsby: "#ccc",
   gatsbyDark: "#ccc",
   github: "#ccc",
   postgresql: "#ccc",
   postgresqlDark: "#ccc",
   restapi: "#ccc",
   restapiDark: "#ccc"
};

export const sizing = {
   borderRadius1: "1rem",
   borderRadius2: "0.8rem",
   borderRadius3: "0.6rem",
   borderRadius4: "0.4rem",
   borderRadius5: "0.3rem"
};

export const fonts = {
   main: "Raleway, sans-serif",
   default: "Poppins, sans-serif",
   num: "Roboto, sans-serif"
};

export const shadows = {
   node: `0 0.4rem 0.4rem ${colors.node}`,
   mongodb: `0 0.4rem 0.4rem ${colors.mongodb}`,
   redux: `0 0.4rem 0.4rem ${colors.redux}`,
   javascript: `0 0.4rem 0.4rem ${colors.javascript}`,
   react: `0 0.4rem 0.4rem ${colors.react}`,
   github: `0 0.4rem 0.4rem ${colors.github}`,
   postgresql: `0 0.4rem 0.4rem ${colors.postgresql}`,
   restapi: `0 0.4rem 0.4rem ${colors.restapi}`,
   gatsby: `0 0.4rem 0.4rem ${colors.gatsby}`
};

/*
	javascript: "#FFEB80",
	javascriptDark: "#FFBD5B",
	node: "#83CD29",
	mongodb: "#98FF9D",
	mongodbDark: "#4CAF50",
	react: "#AFD1FF",
	reactDark: "#78B3FF",
	redux: "#B68CFF",
	reduxDark: "#A586DA",
	gatsby: "#D5AFFD",
	gatsbyDark: "#A577D4",
	github: "#aaa",
	postgresql: "#C8EBFF",
	postgresqlDark: "#3592CA",
	restapi: "#A0F0FF",
	restapiDark: "#52CBE2"
*/
